var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "button",
        {
          staticClass: "btn go-btn-primary",
          staticStyle: { "white-space": "nowrap" },
          attrs: { type: "button" },
        },
        [_vm._v("One Drive")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }